import { Tab, TabList, TabPanels, Tabs } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { Link, ModalConfirm } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { TASK_ID_QUERY_KEY } from "@src/components/widgets/Modals/ModalCommunication/CommunicationModalHeader";
import { TaskTab } from "@src/components/widgets/Modals/ModalCommunication/components/tabs/TaskTab";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";

export const TaskTabs = observer(function TaskTabs() {
  const { taskDetailModalStore: store } = useStore();

  return (
    <Fragment>
      <Tabs
        w="full"
        index={store.currentTabIndex}
        onChange={store.handleChangeTab}
      >
        <TabList
          pos="sticky"
          zIndex="10"
          top="0"
          overflowX={{
            base: "scroll",
            md: "auto",
          }}
          overflowY={{
            base: "hidden",
            md: undefined,
          }}
          px="4"
          bg="white"
        >
          {store.taskTabs.map((tab) => (
            <TaskTab key={tab.id} tab={tab} />
          ))}
          {store.task.value?.parent?.id && store.isInternalUser && (
            <Link
              href={{
                pathname: "/tasks",
                query: {
                  [TASK_ID_QUERY_KEY]: store.task.value?.parent?.id,
                },
              }}
              target="_blank"
            >
              <Tab>
                <Icon
                  name="git-branch-01"
                  color="grey.500"
                  mr="1"
                  w="5"
                  h="5"
                />
                <Trans>Parent task</Trans>
              </Tab>
            </Link>
          )}
        </TabList>

        <TabPanels minH="400px">
          {store.taskTabs.map((tab) => tab.component)}
        </TabPanels>
      </Tabs>

      <ModalConfirm
        isOpen={store.discardModal.isOpen}
        onClose={store.discardModal.onClose}
        onConfirm={() => {
          store.commentChanged = false;
          store.handleChangeCommentInputValue("");
          if (store.newTabId === undefined) return;
          store.activeTabId.set(store.newTabId);
          store.setNewTabId(undefined);
        }}
        confirmBtnTitle={t`Discard changes`}
        destructive
      >
        <Trans>
          Your have unsaved changes. Would you like to discard them?
        </Trans>
      </ModalConfirm>
    </Fragment>
  );
});
